/*eslint-disable eqeqeq */
import axios from 'axios';
import HttpHeader from '../Member/shared/httpheader';
import decryption from '../Member/shared/Decryption';
import generateToken from '../Member/shared/Generatetoken';
import {
  setContentLoader,
  unSetContentLoader,
  setRedirectOnError,
  setIsTokenExpired,
} from '../redux/app/appSlice';
import { logout, setBearerToken, setIsLoggedIn } from '../redux/app/userSlice';
import { SKIPPED_URLS_401 } from '../constants';

let store;
export const injectStore = (_store) => {
  store = _store;
};

export const axiosInstance = window.location.href.includes('localhost:3000')
  ? axios.create()
  : axios.create({ withCredentials: true });
//Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    console.log('API REQUEST ----------' + config?.url);
    console.log('START TIME -----------' + new Date());
    //application/json
    config.headers['Accept'] = 'application/json';
    const currentUrl = config?.url;
    if (window.location.href.includes('localhost:3000')) {
      //Please Uncommentout below line in local environment
      config.headers['isLocal'] = 'true';
    }

    if (!currentUrl.includes('api.ipify.org'))
      config.headers['X-ClientID'] = HttpHeader.getCNAME();

    if (!config.headers['Accept']) {
      config.headers['Accept'] = 'application/json';
    }

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    if (
      currentUrl.includes('/member/eob/entitytype/provider/claimnumber') ||
      currentUrl.includes('/member/idcard/membertype/') ||
      currentUrl.includes('/member/echoidcard/media/PDF/') ||
      currentUrl.includes('/member/echoeobdirect/membertype/')
    ) {
      config.headers['Accept'] = 'application/pdf';
      config.headers['Content-Type'] = 'application/pdf';
    }

    if (currentUrl.includes('/member/getidcard/membertype/')) {
      config.headers['Accept'] = 'image/png';
      config.headers['Content-Type'] = 'image/png';
    }
    if (currentUrl.includes('/member/getidcard/media/Pdf/')) {
      config.headers['Accept'] = 'application/pdf';
      config.headers['Content-Type'] = 'application/pdf';
    }

    if (
      !currentUrl.includes('keystore/getkeystore/name/portal/') &&
      !currentUrl.includes('keystore/getkeystore/name/payload') &&
      !currentUrl.includes('api.ipify.org')
    ) {
      if (!config?.headers?.Authorization) {
        const bearerToken = store.getState().user.bearerToken;
        if (bearerToken) {
          config.headers['authorization'] = bearerToken;
        }
      }
    }
    if (currentUrl.includes('fileuri/name/description/image.jpg')) {
      config.headers['Accept'] = config.headers['Content-Type'];
    }

    if (
      currentUrl.includes('/dms/document/oid/') &&
      config?.method !== 'delete'
    ) {
      config.headers['Accept'] = 'image/png';
    } else {
      const loadingNum = store.getState().app.loadingNum;
      if (loadingNum == 0) {
        store.dispatch(setContentLoader());
      }
    }

    if (!currentUrl.includes('api.ipify.org')) {
      config.params = { ...config.params, cb: Date.now() };
    }

    //config.onDownloadProgress = progressEvent => {
    //console.log('progressEvent', progressEvent)
    //const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    //// do whatever you like with the percentage complete
    //// maybe dispatch an action that will update a progress bar or something
    //// alert(percentCompleted)
    //store.dispatch(setLoadingProgress(percentCompleted || 15));
    //}

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

//Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('API RESPONSE ---------' + response?.config?.url);
    console.log('END TIME -----------' + new Date());
    const currentUrl = response?.config?.url;
    //store.dispatch(setLoadingProgress(100));
    store.dispatch(unSetContentLoader());
    let key = store.getState().key.encryptionValue.SymmetricKey;
    if (currentUrl.includes('keystore/getkeystore/name/payload')) {
      key = response?.data?.Response?.SymmetricKey;
      return response;
    }

    if (
      currentUrl.includes('/dms/document/oid/') ||
      currentUrl.includes(
        '/member/geteoboreop/EntityType/Provider/claimnumber',
      ) ||
      currentUrl.includes('/member/idcard/membertype/')
    ) {
      return response;
    }

    if (currentUrl.includes('keystore/getkeystore/name/portal/') && key) {
      const keyStoreDataResp = decryption(response.data, key);
      const token = generateToken(keyStoreDataResp);

      if (!store.getState().user.bearerToken) {
        store.dispatch(setBearerToken('Bearer ' + token));
      }
      return keyStoreDataResp;
    } else if (currentUrl.includes('/authorization/login/portal/') && key) {
      const loginData = decryption(response.data, key);
      const bearerToken =
        'Bearer ' +
        loginData.Response.access_token +
        ',' +
        loginData.Response.refresh_token;
      store.dispatch(setBearerToken(bearerToken));
      response.data = loginData;
      return response;
    } else if (
      (currentUrl.includes('/register/verifyregistrationexpiry/id') ||
        currentUrl.includes('/register/verifyresetpasswordexpiry/id')) &&
      key
    ) {
      const registrationData = decryption(response.data, key);
      console.log('Axios :::::::::: onboarding>>>>>> ::::: ', registrationData);
      if (
        registrationData?.Response?.LoginResponse?.access_token &&
        registrationData?.Response?.LoginResponse?.refresh_token
      ) {
        const bearerToken =
          'Bearer ' +
          registrationData.Response.LoginResponse.access_token +
          ',' +
          registrationData.Response.LoginResponse.refresh_token;
        store.dispatch(setBearerToken(bearerToken));
      }
      response.data = registrationData;
      return response;
    } else {
      //const token = response.headers.authorization;
      const newToken = response.headers.authorization;
      const oldToken = store.getState().user.bearerToken;

      try {
        if (response.data && typeof response.data === 'string') {
          //store.dispatch( setBearerToken( token ) );
          //if(oldToken != undefined && oldToken != newToken && !currentUrl.includes('/admin/page/oid') && !currentUrl.includes('/admin/medialinks')){
          if (
            oldToken != undefined &&
            oldToken != newToken &&
            !window.location.href.includes('/admin/onboarding') &&
            !window.location.href.includes('/admin/reset-password') &&
            !window.location.href.includes('/member/password-recovery') &&
            !window.location.href.includes('/member/register/emailVerification')
          ) {
            console.log(
              'Axios currentUrl :::::::: >>>>>>>>>>> :::::::::: ',
              currentUrl,
            );
            store.dispatch(setBearerToken(newToken));
          }
          const allData = decryption(response.data, key);
          response.data = allData;
        }
        return response;
      } catch (error) {
        return response;
      }
    }
  },
  (error) => {
    const currentUrl = error?.response?.config?.url;
    store.dispatch(unSetContentLoader());
    const checkSkippedURL = SKIPPED_URLS_401.some((route) =>
      currentUrl.includes(route),
    );

    if (!checkSkippedURL && error?.response?.status === 401) {
      if (store.getState().app.portalType === 'admin') {
        if (
          !window.location.href.includes('/admin/onboarding') &&
          !window.location.href.includes('/admin/reset-password')
        ) {
          store.dispatch(logout());
          store.dispatch(setIsTokenExpired(true));
        }
      }
      if (store.getState().app.portalType === 'member') {
        //store.dispatch( logout() );
        window.location.href = '/member/session-expired';
      }
      //window.location.href = 'session-expired';
    }
    //if (error?.response?.status === 500) {
    //store.dispatch(setRedirectOnError(true));
    //}
    return Promise.reject(error);
  },
);
